import React, { useEffect, useState } from 'react';
import { Tooltip as MuiTooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { TooltipStyled, OptionPanelTooltipStyled } from './styles';

export const Tooltip = props => {
  const {
    type,
    children,
    open,
    title,
    disabled = false,
    placement = 'bottom-end',
    handleClose,
  } = props;
  const intl = useIntl();
  const [closeDisabled, setCloseDisabled] = useState(disabled);

  useEffect(() => {
    if (disabled !== closeDisabled) {
      setCloseDisabled(disabled);
    }
  }, [disabled, open]);

  const handleCloseClick = () => {
    setTimeout(() => {
      if (!closeDisabled && !!handleClose) {
        handleClose();
      }
    }, 100);
  };

  switch (type) {
    case 'hint': {
      const translate = intl.formatMessage({
        id: title,
        defaultMessage: title,
      });

      return disabled ? (
        children
      ) : (
        <MuiTooltip title={translate} arrow>
          {children}
        </MuiTooltip>
      );
    }
    case 'option-panel': {
      return (
        <OptionPanelTooltipStyled
          open={open}
          arrow
          placement={placement}
          title={title}
          leaveDelay={500}
          onClose={handleCloseClick}
        >
          {children}
        </OptionPanelTooltipStyled>
      );
    }
    default: {
      return (
        <TooltipStyled
          open={open}
          arrow
          placement={placement}
          title={title}
          leaveDelay={500}
          onClose={handleCloseClick}
        >
          {children}
        </TooltipStyled>
      );
    }
  }
};
